import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: "Since working with Global Remote, our reviews have skyrocketed. We're now the #1 rated auto shop in our city, and our phone rings off the hook.",
    name: 'Mike R.',
    business: 'AutoCare Plus',
    initial: 'M'
  }, {
    quote: "The automated review system is a game changer. We don't have to awkwardly ask patients for reviews anymore—it just happens automatically.",
    name: 'Dr. Lin',
    business: 'BrightSmile Dental',
    initial: 'L'
  }, {
    quote: 'They optimized our Google profile and within a month we saw a 40% increase in map views. Highly recommend their local SEO services.',
    name: 'Sofia G.',
    business: 'Lima Pizza Co.',
    initial: 'S'
  }];
  return <section id="results" className="py-20 md:py-32 bg-surface" data-id="element-368">
      <div className="container mx-auto px-4 md:px-6" data-id="element-369">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-370">
          <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-navy mb-4" data-id="element-371">
            Helping Businesses Dominate Google Locally
          </h2>
          <p className="text-lg text-muted" data-id="element-372">
            Don't just take our word for it. Here's what our clients have to
            say.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-373">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-card border border-gray-100 flex flex-col" data-id="element-374">
              <div className="flex text-gold mb-6" data-id="element-375">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-376" />)}
              </div>

              <p className="text-ink leading-relaxed mb-8 flex-grow italic" data-id="element-377">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-378">
                <div className="w-12 h-12 rounded-full bg-navy flex items-center justify-center text-gold font-heading font-bold text-xl" data-id="element-379">
                  {testimonial.initial}
                </div>
                <div data-id="element-380">
                  <div className="font-bold text-navy" data-id="element-381">{testimonial.name}</div>
                  <div className="text-sm text-muted" data-id="element-382">
                    {testimonial.business}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}